import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { GroupDetailRequestBody, GroupDetailResponse } from "./types";

export class GroupDetailAPI extends BaseAPI<
  GroupDetailRequestBody,
  GroupDetailResponse
> {
  protected route = ApiRoutes.group.detail;
  protected method = RequestMethod.GET;
  protected params = ["groupId"];
}
